import { render, staticRenderFns } from "./quote.vue?vue&type=template&id=2a825884&scoped=true"
import script from "./quote.vue?vue&type=script&lang=js"
export * from "./quote.vue?vue&type=script&lang=js"
import style0 from "./quote.vue?vue&type=style&index=0&id=2a825884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a825884",
  null
  
)

export default component.exports